(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // ---- Subtle luxury tilt for product cards & category tiles ----
  function initTilt() {
    if (reduceMotion || !canHover) return;
    var items = document.querySelectorAll('.alora-tilt');
    var maxDeg = 5;

    items.forEach(function (item) {
      var target = item.querySelector('a') || item;

      function onMove(e) {
        var rect = item.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var rx = (0.5 - y) * (maxDeg * 2);
        var ry = (x - 0.5) * (maxDeg * 2);
        target.style.transform =
          'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.025) translateZ(0)';
        item.setAttribute('data-tilt-active', '');
      }

      function onLeave() {
        target.style.transform = '';
        item.removeAttribute('data-tilt-active');
      }

      item.addEventListener('mousemove', onMove);
      item.addEventListener('mouseleave', onLeave);
    });
  }

  // ---- Scroll parallax for wrapper elements (hero media on mobile,
  //      cinematic banner media everywhere). Transforms the WRAPPER, never
  //      the <img> inside it, so it never fights an image's own CSS
  //      animation (e.g. the cinematic banner's slow zoom-drift keyframe).
  //      Vertical-only, small amplitude — never scales or crops the photo. ----
  function initScrollParallax() {
    if (reduceMotion) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('.alora-parallax'));
    if (!els.length) return;
    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var strength = parseFloat(el.getAttribute('data-parallax-strength')) || 14;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var offset = progress * strength;
        el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // ---- Hero cursor parallax (desktop only). Three depth layers move by
  //      different, small amounts so the media reads as background, the
  //      buttons as foreground. Mobile/touch never attaches this listener;
  //      the hero's own .alora-hero__media.alora-parallax element still
  //      gets the scroll-based effect above instead. ----
  function initHeroCursorParallax() {
    if (reduceMotion || !canHover) return;
    var heroes = document.querySelectorAll('.alora-hero');

    heroes.forEach(function (hero) {
      var media = hero.querySelector('.alora-hero__media');
      var content = hero.querySelector('.alora-hero__content');
      var actions = hero.querySelector('.alora-hero__actions');

      function onMove(e) {
        var rect = hero.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;

        if (media) media.style.transform = 'translate(' + (x * 6).toFixed(1) + 'px, ' + (y * 6).toFixed(1) + 'px)';
        if (content)
          content.style.transform = 'translate(' + (x * -8).toFixed(1) + 'px, ' + (y * -8).toFixed(1) + 'px)';
        if (actions)
          actions.style.transform = 'translate(' + (x * -12).toFixed(1) + 'px, ' + (y * -12).toFixed(1) + 'px)';
      }

      function onLeave() {
        if (media) media.style.transform = '';
        if (content) content.style.transform = '';
        if (actions) actions.style.transform = '';
      }

      hero.addEventListener('mousemove', onMove);
      hero.addEventListener('mouseleave', onLeave);
    });
  }

  function init() {
    initTilt();
    initScrollParallax();
    initHeroCursorParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
